import React, {useState, useRef, useEffect} from 'react';
import {motion} from 'motion/react';
import tabContainerBg from '../../assets/daily-tab-container.webp';
import tabBg from '../../assets/daily-tab.webp';

interface TabContainerProps {
  onTabChange?: (tab: 'today' | 'yesterday') => void;
  activeTab?: 'today' | 'yesterday';
}

export default function TabContainer({
  onTabChange,
  activeTab = 'today',
}: TabContainerProps) {
  const [currentTab, setCurrentTab] = useState<'today' | 'yesterday'>(
    activeTab,
  );
  const [tabWidth, setTabWidth] = useState(125); // 默认值，会在useEffect中更新
  const containerRef = useRef<HTMLDivElement>(null);

  const handleTabClick = (tab: 'today' | 'yesterday') => {
    setCurrentTab(tab);
    onTabChange?.(tab);
  };

  // 同步外部 activeTab 状态
  useEffect(() => {
    setCurrentTab(activeTab);
  }, [activeTab]);

  // 动态计算tab宽度
  useEffect(() => {
    const calculateTabWidth = () => {
      if (containerRef.current) {
        // 获取容器的实际宽度，然后除以2得到单个tab的宽度
        const containerWidth = containerRef.current.offsetWidth;
        const calculatedTabWidth = containerWidth / 2;
        setTabWidth(calculatedTabWidth);
      }
    };

    calculateTabWidth();

    // 监听窗口大小变化
    window.addEventListener('resize', calculateTabWidth);

    return () => {
      window.removeEventListener('resize', calculateTabWidth);
    };
  }, []);

  // 动态计算滑块位置
  const tabIndex = currentTab === 'today' ? 0 : 1;
  const sliderPosition = tabIndex * tabWidth;

  // Tab配置
  const tabs = [
    {key: 'today' as const, label: 'Today'},
    {key: 'yesterday' as const, label: 'Yesterday'},
  ];

  return (
    <div className="flex justify-center z-1000">
      <div className="relative" ref={containerRef}>
        <div
          className="w-[15.625rem] h-[2.1875rem] flex items-center text-[#C9860266] text-sm font-bold capitalize bg-full"
          style={{backgroundImage: `url(${tabContainerBg})`}}>
          {tabs.map(tab => (
            <button
              key={tab.key}
              className={`flex-1 text-center z-10 transition-colors duration-200 ${
                currentTab === tab.key ? 'text-[#2E2013]' : 'text-[#C9860266]'
              }`}
              onClick={() => handleTabClick(tab.key)}>
              {tab.label}
            </button>
          ))}
        </div>

        {/* 滑块动画 */}
        <motion.div
          className="w-[7.8125rem] h-[2.1875rem] bg-full absolute top-0"
          style={{backgroundImage: `url(${tabBg})`}}
          animate={{
            x: sliderPosition,
          }}
          transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30,
            mass: 0.8,
          }}
        />
      </div>
    </div>
  );
}
